export default {
  date_sameDay: '[Сьогодні о] HH:mm',
  date_lastDay: '[Вчора о] HH:mm',
  date_lastWeek: 'dddd HH:mm',
  date_sameElse: 'DD MMMM YYYY [о] HH:mm',
  // auh_view
  accountRestrictedGoToKyc: 'Можливості вашого акаунту обмежені. Для отримання доступу до повного функціоналу пройдіть',
  auth_copyright: '© DIT',
  disposable_mail_error: 'Адреса пошти з забороненого домену',
  invalid_email_error: 'Неправильна адреса електронної пошти',
  expired_signature: 'Помилка простроченого підпису. Перевірте правильність часу на своєму пристрої та спробуйте ще раз',
  not_found: 'Неправильний email або пароль',
  email_not_verified_on_recovery: 'Неможливо відновити обліковий запис з неперевіренною електронною поштою',
  email_verified: 'Електронная пошта успішно підтверджена',
  email_not_verified: 'Електронная пошта не підтверджена. Будь ласка, перевірте свою електронну пошту',
  email_sent: 'Запит успішно надіслано. Будь ласка, перевірте свою електронну пошту',
  password_not_verified: 'Неправильний пароль',
  password_do_not_match: 'Паролі не співпадають',
  password_change_failed: 'Не вдалось змінити пароль. Спробуйте пізніше',
  password_changed: 'Пароль успішно змінено',
  recovery_wallet_not_found: 'Неправильна пошта або ключ відновлення',
  role_mail_error: 'Рольові адреси пошти заборонені',
  recovered: 'Акаунт успішно відновлено. Тепер ви можете увійти з новими обліковими даними',
  tfa_wrong_code: 'Неправильний код',
  tfa_recovery: 'Двофакторну автентифікацію втрачено. Двофакторну автентифікацію можна відновити в налаштуваннях',
  tfa_recovery_unblocked: 'Двофакторну автентифікацію успішно скинуто',
  user_exists: 'Користувач с такою поштою вже існує',
  wrong_password: 'Неправильний пароль',
  tfa_disabled: 'Двухфакторна аутентифікація успішно відключена',
  auth_and: 'і',
  recovery_title: 'Відновлення аккаунту',
  recovery_description: 'Знаєте реквизити для входу?',
  // common
  cm_complete_validation: 'Заповніть всі обов\'язкові поля перед тим, як продовжити',
  cm_balance_created: '%{code} успішно додано до вашого гаманця',
  cm_error_occured: 'Помилка. Будь ласка, спробуйте пізніше',
  // contracts_view
  cont_signed: 'Підписано',
  cont_counterparty_name: "Ім'я, електрона пошта чи ID аккаунта контрагента",
  cont_counterparty_email_or_id: 'Пошта чи ID акаунта контрагента',
  cont_contract_number: 'Номер контракту',
  cont_show_active_disputes: 'Показати тільки активні контракти',
  cont_counterparty: 'Контрагент',
  cont_no_signed_contracts: 'Немає підписаніх контрактів',
  cont_no_signed_contracts_desc: 'Тут буде відображатися список підписаних Вами контрактів',
  cont_active_disputes: 'Активні обговорення',
  cont_details: 'Деталі контракта',
  cont_company_id: 'ID аккаунт компанії',
  cont_new_contract: 'Новий контракт',
  cont_sign_and_send: 'Підписати і відправити',
  cont_sign_and_send_to_counterparty: 'Підписати і відправити контрагенту',
  cont_signature_requests: 'Запити на підпис',
  cont_no_archived_contracts: 'Немає архівованих контрактів',
  cont_no_archived_contracts_desc: 'Тут буде відображатися список архівованих контрактів',
  cont_no_contract_requests: 'Немає контрактних запитів',
  cont_no_contract_requests_desc: 'Тут буде відображатися список контрактних запитів',
  cont_no_invoice_requests: 'Немає запитів на виставлення рахунків',
  cont_no_invoice_requests_desc: 'Тут буде відображатисяя перелік Ваших запитів на витсавлення рахунку',
  cont_invoice_number: 'Номер рахунку',
  cont_invoice_information: 'Інформація про рахунок',
  cont_dispute_information: 'Інформація про спір',
  cont_appeal_to_escrow: 'Звернення до Escrow',
  cont_resolve_the_dispute: 'Вирішити спір',
  cont_start_a_dispute: 'Почати спір',
  cont_confirm_the_payment: 'Підтвердіть платіж',
  cont_create_invoice: 'Створити новий рахунок',
  cont_invoices: 'Рахунки',
  cont_invoice_amount: 'Кількість %{asset}',
  cont_email_invalid: 'Невірний Email контрагента',
  cont_counterparty_invalid: 'Невірна назва контрагента',
  cont_pending_status: 'В очікуванні підпису зі сторони контрагента',
  cont_type_outgoing: 'Вихідний',
  cont_type_incoming: 'Вхідний',
  cont_sign: 'Підписати',
  contract_signed: 'Контракт підписано',
  contract_rejected: 'Контракт відхилено',
  contract_completed: 'Контракт складено',
  cont_invoice_confirmed: 'Рахунок підтверджено',
  cont_invoice_rejected: 'Рахунок відхилено',
  cont_contract_confirmed: 'Платежі по контракту підтверджено',
  cont_confirm_completed: 'Підтвердження виконано',
  cont_dispute_submitted: 'Спір передано на розгляд',
  cont_invoice_created: 'Рахунок відправлено',
  cont_appeal_success: 'Апеляція до умовного депонування успішно відправлена',
  cont_appeal_escrow_by: 'Обращение к условному депонированию',
  cont_escrow_resolution: 'Вирішення угоди',
  // company_view
  com_all: 'Усі',
  com_upcoming_only: 'Запланований',
  com_live: 'Активний',
  com_closed: 'Завершений',
  com_state_as_status: 'Статус',
  com_search: 'Шукати краудфандинговий проєкт',
  com_sort_launch_date: 'Дата старту',
  com_sort_soonest: 'Дата фінішу',
  com_sort_popularity: 'Популярності',
  com_no_sales_found: 'Ми не знайшли проєкт зі схожою назвою',
  com_no_sales_found_desc: 'Перевірте написання,спробуйте пошукати за кодом активу або використайте фільтри',
  com_name: 'Назва компанії',
  com_date_of_foundation: 'Дата заснування',
  com_homepage: 'Домашня сторінка',
  com_industry_tags: 'Галузь / Мітки',
  com_team_size: 'Розмір команди',
  com_type: 'Тип компанії',
  com_headquarters: 'Головний офіс',
  com_email: 'Email компанії',
  com_website: 'Вебсайт компанії',
  com_earned: 'Зібрано',
  com_target: 'Ціль збору',
  com_profitability: 'Доходність',
  com_investors: 'Інвестори',
  com_campaign: 'Проєкт',
  // dashboard_view
  dash_activity: 'Остання активність',
  dash_wallet: 'Ваш гаманець',
  total_wallet: 'Усього',
  gray_wallet: 'Сіра',
  white_wallet: 'Біла',
  dash_verification: 'Пройдіть верифікацію, щоб отримати доступ до всіх функцій платформи',
  dash_verification_wait: 'Ваші документи ще перевіряються',
  // fees
  fees_your_fees: 'Комісії вашого активу %{asset} ',
  fees_asset: 'Актив',
  fees_payment_fee: 'Комісія за переказ',
  fees_offer_fee: 'Запропонована комісія',
  fees_withdrawal_fee: 'Комісія за вивід',
  fees_issuance_fee: 'Комісія за випуск',
  fees_invest_fee: 'Комісія за інвестицію',
  fees_incoming_outgoing: 'Вхідна і вихідна',
  fees_outgoing: 'Вихідний',
  fees_incoming: 'Вхідний',
  fees_fee_type: 'Тип комісії',
  fees_fixed: 'Фіксована',
  fees_percent: 'Відсоток',
  fees_lower_bound: 'Нижній кордон',
  fees_upper_bound: 'Верхній кордон',
  fees_subtype: 'Підтип',
  fees_percent_fixed: 'Комісія: %{percent}% + %{fixed} %{currency}',
  fees_will_charged: 'З балансу буде списано %{willCharged} %{currency}',
  fees_load_fail: 'Не вдалось завантажити комісії',
  lbl_fees_label: 'Комісія',
  // file-upload
  max_file_size_exceeded: 'Максимальний розмір файлу складає %{size} Мб. Будь ласка, завантажте файл меншого разміру',
  min_file_size_fail: 'Мінімальний розмір файлу складає %{size} Мб. Будь ласка, завантажте файл більшого розміру',
  min_image_width_fail: 'Ширина зображення повинна бути більше ніж %{width}',
  min_image_height_fail: 'Висота зображення повинна бути більше ніж %{height}',
  min_image_dimension_fail: 'Ширина і висота зображення повинні бути більше ніж %{width}x%{height}',
  unsupported_extension: 'Вибачте, %{ext} не підтримується',
  max_size: 'Максимальний розмір %{size} Мб',
  fi_no_file_chosen: 'Файл не обрано',
  fi_upload_file: 'зображення або pdf (максимальний. розмір %{size} Мб)',
  fi_view_file: 'Переглянути файл',
  fi_upload_iss_file: 'Файл для випуску активу',
  fi_upload_csv_file: 'Обрати файл(и) (до %{size} мб)',
  file_incorrect_type: 'Некоректний формат файлу',
  // inactivity_message
  inm_session_timeout: 'Час сесії вичерпано',
  inm_session_timeout_descr: 'Час сесії вичерпано через тривалу відсутність діяльності',
  // labels
  signup_password: '"пароль"',
  lbl_import_image_details: 'Мінімальний розмір: 120х120, не більше 5 МБ\nДопустимі формати: PNG, JPG, GIF, BMP',
  lbl_import_image_details_campaign: 'Мінімальний розмір: 290х170, не більше 5 МБ\nДопустимі формати: PNG, JPG, GIF, BMP',
  lbl_confirmation_sent: 'Лист з підтвердженням було надіслано на електронну пошту %{mail}. Будь ласка, перевірте електронну пошту та підтвердіть її.',
  lbl_check_spam: 'Якщо ви не отримали листа с підтвердженням, перевірте папку "Спам".',
  lbl_seed_dont_match: 'Seed-фразу введено з помилками',
  lbl_select_files: 'Обрати файл(и)',
  lbl_contact_us: 'Зв\'яжіться з нами',
  lbl_transactions: 'Транзакції',
  lbl_dashboard: 'На головну',
  lbl_history_menu: 'Історія',
  lbl_investment_portfolio: 'Історія інвестицій',
  lbl_portfolio_investments: 'Історія інвестицій',
  lbl_available: 'Доступно',
  lbl_locked: 'Заблоковано',
  lbl_current_price: 'Поточна ціна:',
  lbl_exchange_rates: 'Курси валют по відношенню до %{asset}',
  lbl_no_investment_tokens: 'У вашому портфоліо немає інвестиційних активів',
  lbl_no_investment_tokens_desc: 'Тут буде перелік ваших інвестиційних активів',
  lbl_user_info: 'Дані користувача',
  lbl_email: 'Email',
  lbl_pwd: 'Пароль',
  lbl_new_pwd: 'Новий пароль',
  lbl_pwd_confirm: 'Підтвердіть пароль',
  lbl_confirm: 'Підтвердити',
  lbl_asset: 'Актив',
  lbl_create_wallet: 'Створити гаманець',
  lbl_choose_asset: 'Оберіть актив',
  lbl_amount: 'Сума',
  lbl_give: 'Віддаю',
  lbl_get: 'Отримую',
  lbl_almost_done: 'Майже готово',
  lbl_request_new_email: 'Запросити лист ще раз',
  lbl_settings: 'Налаштування',
  lbl_verification: 'Верифікація',
  lbl_acc_verification: 'Верифікація акаунту',
  lbl_help: 'Допомога',
  lbl_signout: 'Вийти',
  lbl_signin: 'Увійти',
  lbl_signup: 'Зареєструватися',
  lbl_logout: 'Вийти',
  lbl_zeros: 'Приховати нульові баланси',
  lbl_my_account: 'Мій обліковий запис',
  lbl_account: 'Обліковий запис',
  lbl_account_info: 'Обліковий запис',
  lbl_account_type: 'Тип акаунту',
  lbl_taurus_id: 'UPLATA карта',
  lbl_uplata_insha_name: 'Visa Iнша',
  lbl_uplata_insha: 'Карти Visa Iнша',
  lbl_no_uplata_insha: 'Карти Visa Iнша відсутні',
  lbl_no_xpay: 'Карти відсутні',
  lbl_xpay: 'Платіжні карти',
  lbl_no_card: 'Карта не обрана',
  lbl_add_xpay: 'Введіть номер платіжної карти для додання',
  lbl_invalid_uplata_len: '16-ти значний номер',
  lbl_add_uplata_insha: 'Номер карти Visa Iнша',
  lbl_taid: 'Карти UPLATA',
  lbl_no_taid: 'Карти UPLATA відсутні',
  lbl_invalid_taid_len: 'введіть 7-ми значний номер',
  lbl_add_taurus: 'Номер карти UPLATA',
  lbl_number_is_exists: 'Номер вже є у списку карт',
  lbl_auto_withdraw: 'автовивід',
  lbl_delete_confirm_title: 'Підтвердження видалення',
  lbl_delete: 'Видалити',
  lbl_card_add: 'Додати карту',
  lbl_card_delete: 'видалити карту',
  lbl_id_delete_confirm: 'Ви дійсно бажаєте видалити карту %{id} ?',
  lbl_id_add_confirm: 'Ви дійсно бажаєте додати карту %{id} ?',
  lbl_autowithdraw_confirm: 'Ви дійсно бажаєте змінити параметри автовиводу?',
  lbl_exchange: 'Обмін',
  lbl_verified: 'Верифікований користувач',
  lbl_got_it: 'Зрозуміло',
  lbl_unverified: 'Непідтверджений користувач',
  lbl_not_verified: 'не підтверджено',
  lbl_confirm_send: 'Підтвердити відправку',
  lbl_enter_quantity: 'Введіть кількість',
  lbl_back_to_sale: 'Повернутися до проєкту',
  lbl_email_2: 'Пошта',
  lbl_tokens_assets: 'Кількість активів',
  lbl_accept: 'Підтверджую',
  lbl_go_to_pay: 'Перейти до виплати',
  lbl_go_to_section: 'Перейдіть у розділ ',
  lbl_pdf_5mb: 'Тільки формат PDF, не більше 5 МБ',
  lbl_dividends_pay: 'Виплата дивидендів',
  lbl_publish_file: 'Опублікувати',
  lbl_copy: 'Скопіювати',
  lbl_notifications: 'Повідомлення',
  lbl_lost_2fa: 'Втратив 2FA',
  lbl_add_2fa: 'Додайте 2-факторну автентифікацію',
  lbl_recover_2fa: 'Відновити 2-факторну автентифікацію',
  pending: 'очікує верифікації',
  approved: 'підтверджено',
  rejected: 'відхилено',
  tx_from: 'від',
  tx_to: 'вихідна',

  tx_issuance: 'Емісія',
  tx_investment: 'Інвестиція',
  tx_match: 'Закриття заявки',
  tx_withdrawal: 'Вивід',
  tx_transfer: 'Переказ',
  tx_offer: 'Пропозиція',
  tx_invoice: 'Інвойс',

  tx_state_confirm: 'успіх',
  tx_state_success: 'успіх',
  tx_state_failed: 'невдача',
  tx_state_rejected: 'відхилено',
  tx_state_pending: 'очікується',
  tx_state_fully_matched: 'заявка закрита',
  tx_greater_than_balance: 'Сума перевищує баланс',
  tx_blocks_separator: 'або',
  lbl_my_wallet: 'Гаманець',
  lbl_deposit: 'Зарахувати',
  lbl_deposit_white: 'На білий гаманець',
  lbl_refund: 'Повернути',
  lbl_reason: 'Причина',
  lbl_aml_title: 'Транзакція потребує уваги',
  lbl_aml_title_large: 'Транзакція потребує уваги. Виявлено підвищені ризикові показники або сталася помилка обробки. Перевірте деталі нижче та прийміть рішення.',
  lbl_check_again: 'Перевірити знову',
  lbl_withdraw: 'Вивід',
  lbl_refill: 'Поповнити',
  lbl_withdrawal_req: 'Заявки на вивід',
  lbl_refund_history: 'Історія повернень',
  lbl_send: 'Відправити',
  lbl_send_immediatly: 'Відправити негайно',
  lbl_send_mass: 'Масовий переказ',
  lbl_cashbox: 'Заявки в касу',
  lbl_tokens: 'Токенізація',
  lbl_trade: 'Торгівля',
  lbl_create_token: 'Створити актив',
  lbl_create_sale: 'Створити проєкт',
  lbl_creation_sale: 'Створення проєкту',
  lbl_tokens_management: 'Управління токенами',
  lbl_explore_tokens: 'Доступні активи',
  lbl_explore_sales: 'Пошук проєктів',
  lbl_my_funds: 'Мої проєкти',
  lbl_history: 'Історія транзакцій',
  lbl_history_w: 'Історія знять',
  lbl_history_e: 'Історія поповнень',
  lbl_business_directory: 'Каталог проєктів',
  lbl_cancel: 'Відміна',
  lbl_withdrawal_cancel: 'Відмінити вивід',
  lbl_sub_transfer: 'Перевод',
  lbl_export: 'Експорт',
  lbl_wallet: 'Гаманець',
  lbl_one_time_wallet: 'Гаманець одноразовий',
  lbl_client_wallet: 'Гаманець клієнта',
  lbl_wallet_onetime: 'Одноразовий гаманець',
  lbl_something_wrong: 'щось пішло не так, спробуйте пізніше',
  lbl_enroll: 'Зарахувати',
  lbl_put_aside: 'Відкласти',
  lbl_credit_dirty: 'На сірий гаманець',
  lbl_main_user_id: 'Main user id',
  lbl_current_lvl: 'Очікуваний рівень підпису',
  lbl_total_levels: 'Всього необхідно рівнів',
  lbl_user_id: 'ID користувача',
  lbl_date: 'Дата',
  lbl_check_crystal: 'Перевірити вручну в Crystal',
  lbl_time_optional: 'Час',
  lbl_time_to_tx: 'Час до відправки транзакції',
  lbl_cancel_refund: 'Скасувати повернення',
  lbl_time_to_refund: 'Ви можете скасувати повернення, доки не завершиться відлік таймера',
  lbl_id: 'ID',
  lbl_temporary_wallet: 'Тимчасовий гаманець',
  lbl_refund_amount: 'Сума повернення',
  lbl_address: 'Адреса',
  lbl_address_refund: 'Адреса повернення',
  lbl_commision: 'Комісія',
  lbl_refund_address: 'Адреса повернення',
  lbl_sum_refund: 'Сума повернення',
  lbl_refund_canceled: 'Помилка',
  lbl_refund_success: 'Успіх',
  lbl_refund_pending: 'Очікується',
  lbl_refund_balance: 'Баланс',
  lbl_refund_asset: 'Валюта',
  lbl_refund_date: 'Дата створення',
  lbl_refund_hash: 'Хэш',
  lbl_refund_status: 'Статус',
  lbl_refund_number: 'Номер заявки',
  lbl_to_app: 'До додатку', // назад к приложению
  lbl_hash: 'Хеш',
  lbl_client_hash: 'Хеш клієнта',
  lbl_order_id: 'Номер заявки',
  lbl_order_uid: 'ID заявки',
  lbl_internal_hash: 'Внутрішній хеш',
  lbl_order_amount: 'Сума за заявкою',
  lbl_order_network: 'Мережа за заявкою',
  lbl_tx_type: 'Тип транзакції',
  lbl_status: 'Статус',
  lbl_my: 'Доступні заявки',
  lbl_pending: 'Очікується',
  lbl_aml_pending: 'Очікується AML перевірка',
  lbl_confirmed: 'Підтверджено',
  lbl_canceled: 'Відхилено',
  lbl_approvers: 'Затверджувачі',
  lbl_signatures: 'Підписи',
  lbl_level: 'Рівень',
  lbl_level_1: 'Операціоніст',
  lbl_level_2: 'Контролер',
  lbl_level_3: 'Керівник напрямку',
  lbl_level_4: 'Директор',
  lbl_check_sign: 'Очікує підписання',
  lbl_check_sign_again: 'Перевірити знову',
  lbl_balance: 'Баланс',
  lbl_counterparty: 'Контрагент',
  lbl_sender: 'Відправник',
  lbl_receiver: 'Отримувач',
  lbl_fixed_fee: 'Фіксована комісія',
  lbl_percent_fee: 'Відсоткова комісія',
  lbl_total_fee: 'Загальна комісія',
  lbl_add_note: 'Додати опис',
  lbl_description: 'Опис',
  lbl_client: 'Клієнт',
  lbl_direction_group: 'Група напрямку',
  lbl_client_group: 'Група клієнта',
  lbl_fund_name: 'Назва проєкту',
  lbl_sale_name: 'Назва проєкту',
  lbl_exchange_asset: 'Валюта',
  lbl_limit_s: 'Сума нижче мінімального ліміту поповнення',
  lbl_limit_title: 'Ліміт поповнення',
  lbl_exchange_buy: 'Покупка',
  lbl_exchange_sell: 'Продаж',
  lbl_base_asset: 'Базовий актив',
  lbl_default_quote_asset: 'Другий актив',
  lbl_fee_paid: 'Комісія сплачена',
  lbl_price: 'Ціна',
  lbl_transfer_fee: 'Комісія за переказ',
  lbl_destination_asset: 'Цільовий актив',
  lbl_destination_amount: 'Цільова сума',
  lbl_source_amount: 'Заявлена сума',
  lbl_ok: 'Ок',
  lbl_tfa_code: '2FA код',
  lbl_add: 'Додати',
  lbl_add_more: 'Додати ще',
  lbl_added_video: 'Додані відео:',
  lbl_submit: 'Прийняти',
  lbl_secret: 'Секретне слово',
  lbl_recovery_seed: 'Код для відновлення',
  lbl_transaction_details: 'Деталі транзакції',
  lbl_view_more: 'Дивитись більше',
  lbl_all_history: 'Вся історія',
  lbl_all: 'Усі',
  lbl_mine: 'Мої',
  lbl_close: 'Відміна',
  lbl_recipient_email_or_account: 'Email отримувача або ID облікового запису',
  lbl_recipient_email: 'Email отримувача',
  lbl_recipient: 'Отримувач',
  lbl_recipient_account_id: 'ID облікового запису отримувача',
  lbl_recipient_balance_id: 'ID балансу отримувача',
  lbl_requestor: 'Контрагент',
  lbl_requestor_account_id: 'ID облікового запису контрагента',
  lbl_requestor_id_or_email: 'ID або email контрагента',
  lbl_recipient__email: 'Email отримувача',
  lbl_source_fees: 'Комісії відправника',
  lbl_fixed_percent: '(Фіксована/відсоткова)',
  lbl_destination_fees: 'Системний збір',
  lbl_recipient_fixed_fee: 'Фіксована комісія отримувача',
  lbl_recipient_percent_fee: 'Відсотковий збір отримувача',
  lbl_sender_balance_id: 'ID баланс отримувача',
  lbl_sender_fixed_fee: 'Фіксована комісія отримувача',
  lbl_sender_percent_fee: 'Відсотковий збір отримувача',
  lbl_fixed: 'Фікс',
  lbl_percent: 'Відсоток',
  lbl_subject: 'Предмет',
  lbl_token_code: 'Код активу',
  lbl_token_name: 'Назва активу',
  lbl_token_icon: 'Завантажити зображення',
  lbl_token_terms: 'Завантажити умови',
  lbl_token_preissued_asset_signer: 'Підписант випуску активу',
  lbl_token_max_issuance_amount: 'Максимальна сума випуску',
  lbl_token_policies: 'Політика',
  lbl_token_initial_preissued_amount: 'Початкова сума випуску',
  lbl_is_transferable: 'Створити переказний актив',
  lbl_is_additional_issuance_allowed: 'Дозволений додаткой випуск',
  lbl_is_tradable: 'Торгуємий',
  lbl_fees: 'Комісія',
  lbl_sender_fees: 'Комісії відправника',
  lbl_recipient_fees: 'Комісії отримувача',
  lbl_go_back: 'Повернутись',
  lbl_delete_notif: 'Видалити це повідомлення',
  lbl_go_back_2: 'Назад',
  lbl_make_recovery: 'Відновити',
  lbl_validate_seed: 'Введіть seed-фразу',
  lbl_seed: 'Seed-фраза',
  lbl_first_name: 'Им\'я',
  lbl_last_name: 'Прізвище',
  lbl_line_1: 'Строка 1',
  lbl_line_2: 'Строка 2',
  lbl_city: 'Місто',
  lbl_country: 'Країна',
  lbl_state: 'Статус',
  lbl_postal_code: 'Поштовий індекс',
  lbl_kyc: 'Обліковий запис користувача',
  lbl_kyc_photo: 'Фото',
  lbl_kyc_selfie: 'Знімок',
  lbl_kyc_id: 'Документ посвідчення особи',
  lbl_kyc_proof: 'Підтвердження адреси',
  lbl_done: 'Готово',
  lbl_date_of_birth: 'Дата народження',
  lbl_id_document_exp_date: 'Термін дії документу посвідчення особи',
  lbl_code: 'Код',
  lbl_document_type: 'Тип документу',
  lbl_owner: 'Власник',
  lbl_avalilable_for_iss: 'Доступно',
  lbl_name: 'Назва',
  lbl_signer: 'Підписант',
  lbl_maximum: 'Максимум',
  lbl_max_issuance: 'Максимум',
  lbl_issued: 'Випущено',
  lbl_policy: 'Політика',
  lbl_policies: 'Політики',
  lbl_terms: 'Умови',
  lbl_token_details: 'Деталі активу',
  lbl_add_to_balances: 'Додати до мого гаманця',
  lbl_balance_exists: 'Додано до гаманця',
  lbl_view_history: 'Подивитись історію',
  lbl_user: 'Користувач',
  lbl_sub: 'Суб акаунт',
  lbl_new: 'Новий',
  lbl_new_dir: 'Новий напрямок',
  lbl_new_client: 'Новий клієнт',
  lbl_subs: 'Суб акаунти',
  lbl_direction: 'Направлення',
  lbl_no_wallets: 'Немає субакаунтів для цієї валюти',
  lbl_no_funds: 'Нерозподілені кошти',
  lbl_sub_edit: 'Редагувати',
  lbl_aml_notify: 'AML нотификації',
  lbl_aml_notify_inc: 'Вхідні — повідомлення AML',
  lbl_aml_notify_out: 'Вихідні — повідомлення AML',
  lbl_aml_error_out: 'Вихідні — повідомлення про помилки AML',
  lbl_aml_error_inc: 'Вхідні — повідомлення про помилки AML',
  lbl_manual_aml_review: 'На ручній AML перевірці',
  lbl_lymit_notify: 'Лимітні нотификації',
  lbl_inc_notify: 'Вхідні нотификації',
  lbl_out_notify: 'Вихідні нотификації',
  lbl_group_name: 'Групувати по клієнту',
  lbl_group_decs: 'Групувати по напрямку',
  lbl_add_group_decs: 'Додатково групувати по напрямку',
  lbl_add_group_client: 'Додатково групувати по клієнту',
  lbl_group_add: 'всі',
  lbl_userBlocked: 'Користувач заблокований',
  lbl_requests: 'Запити',
  lbl_fee: 'Комісії',
  lbl_giftmall: 'Магазин',
  lbl_request_state: 'Стан запиту',
  lbl_token_creation: 'Створення активу',
  lbl_sale_creation: 'Створення проєкту',
  lbl_manual_issuance: 'Мануальний випуск',
  lbl_token_creation_requests: 'Запити на створення активу',
  lbl_choose_image: 'Оберіть зображення з вашого пристрою',
  lbl_chose_image_token: 'Перетягніть сюди зображення,<br> яке стане логотипом вашого активу',
  lbl_chose_image_campaign: 'Перетягніть сюди зображення,<br> яке стане прев\'ю вашого проєкту',
  lbl_no_token_creation_requests: 'Немає запитів на створення активу',
  lbl_no_token_creation_requests_desc: 'Тут буде відображений список ваших запитів на створення аткиву',
  lbl_created_at: 'Дата створення ',
  lbl_revoked: 'Відізвано',
  lbl_updated_at: 'Оновлений о ',
  lbl_update: 'Оновити',
  lbl_reference: 'Посилання',
  lbl_view_sale: 'Подивитись проєкт',
  lbl_create_issuance: 'Створити емісію',
  lbl_sender_fee: 'Комісія відправника',
  lbl_recipient_fee: 'Комісія отримувача',
  lbl_fee_from_source: 'Комісія оплачена відправником',
  lbl_sender_fee_asset: 'Комісія відправника',
  lbl_recipient_fee_asset: 'Комісія отримувача',
  lbl_sort_by: 'Сортувати за',
  lbl_reject_message: 'Відхилити повідомлення',
  lbl_information: 'Інформація',
  lbl_not_available: 'Будь ласка, зачекайте',
  lbl_token_not_available_exp: 'Створювати активи можуть лише корпоративні користувачі.\nДля того, щоб стати корпоративним користувачем, пройдіть верифікацію.',
  lbl_token_not_available_yet: 'Будь ласка, створіть актив перед тим, як створити проєкт',
  lbl_issuance_not_available_exp: 'Емісію можуть створювати тільки корпоративні користувачі. Для того, щоб стати корпоративним користувачем, пройдіть верифікацію.',
  lbl_issuance_not_available_yet: 'Будь ласка, створіть актив перед тим, як провести емісію',
  lbl_preissuance_not_available_exp: 'Завантаження файлу для випуску доступне тільки для корпоративних користувачей. Для того, щоб стати корпоративним користувачем, пройдіть верифікацію.',
  lbl_not_available_exp: '% {screen} доступний тільки для верифікованих користувачів. Пройдіть, будь ласка, верифікацію.',
  lbl_upload_preissuance: 'Створити ємісію',
  lbl_clear: 'Очистити',
  lbl_upload: 'Завантажити',
  lbl_company: 'Компанія',
  lbl_headquarters: 'Головний офіс',
  lbl_industry: 'Галузь',
  lbl_founded: 'Дата заснування',
  lbl_team_size: 'Розмір команди',
  lbl_homepage: 'Домашня сторінка',
  lbl_edit_details: 'Редагувати деталі',
  lbl_loading: 'Завантаження...',
  lbl_your_wallet: 'Ваш гаманець',
  lbl_one_time_wallet_address: 'Адреса одноразового гаманця',
  lbl_wait_30: 'Будь ласка, використовуйте адресу одноразового гаманця нижче, поки не завершиться відлік таймера',
  lbl_timer_error: 'щось пішло не так перезавантежте сторінку',
  lbl_create_btn: 'Нове поповнення',
  lbl_no_data: 'Немає даних',
  lbl_to_upload: 'Для завантаження:',
  lbl_street_name: 'Назва вулиці',
  lbl_upload_docs: 'Будь ласка, завантажте наступні документи',
  lbl_upload_doc: 'Будь ласка, завантажте наступний документ',
  lbl_agree_submit: 'Згоден і підтверждую інформацію',
  lbl_pay_all_fees: 'Сплата коміссії',
  lbl_residence_country: 'Країна проживання',
  lbl_zip_code: 'Поштовий індекс',
  lbl_limits: 'Ліміти',
  lbl_note: 'Примітка',
  lbl_send_request: 'Надіслати запит',
  lbl_to: 'Кому',
  lbl_request_type: 'Тип запиту',
  lbl_more: 'Більше',
  lbl_upload_documents: 'Завантажити документи',
  lbl_request_creation_date: 'Дата створення запиту',
  lbl_requesting: 'Запит',
  lbl_contracts: 'Контракти',
  lbl_market: 'Маркет',
  lbl_start_date: 'Дата початку',
  lbl_end_date: 'Дата фінішу',
  lbl_yes: 'Так',
  lbl_no: 'Ні',
  lbl_documents: 'Документ',
  lbl_document: 'Документ',
  lbl_submitted_by: 'Надано',
  lbl_type: 'Тип',
  lbl_archive: 'Архів',
  lbl_reject: 'Відхилити',
  lbl_funds: 'Проєкти',
  lbl_projects: 'Проєкти',
  lbl_open: 'Відкрити',
  lbl_reject_request: 'Запит відхилено',
  lbl_reject_reason: 'Причина відмови',
  lbl_contracts_not_available_exp: 'Контракти доступні лише для верифікованих користувачів. Пройдіть, будь ласка, верифікацію.',
  lbl_see_details_in_contract: 'Дивіться деталі в контракті.',
  lbl_invoice_number: 'Номер інвойсу',
  lbl_card_add_uplata: 'Введіть Uplata TaID для додання карти',
  lbl_current_balance: 'Ваш баланс: %{amount} %{asset}',
  lbl_sub_current_balance: 'Баланс суб гаманця: %{amount} %{asset}',
  lbl_campaign_status: 'Статус проєкту',
  lbl_search_campaign: 'Пошук за назвою проєкту...',
  lbl_search_btn: 'Знайти',
  lbl_history_btn: 'Історія делегувань',
  lbl_from: 'Від',
  lbl_delegate_btn: 'Делегувати',
  lbl_return_btn: 'Відізвати',
  lbl_delegate_text: 'Ви делегували свої права',
  lbl_delegated_to_you: 'Вам були делеговані права від %{user} ваш рівень зараз %{level} закінчується %{date}',
  lbl_status_open: 'активний',
  lbl_status_canceled: 'скасований',
  lbl_status_closed: 'завершений',
  lbl_month: 'місяць',
  lbl_months: 'місяці',
  lbl_months_2: 'місяці',
  lbl_back_to_settings: 'Повернутись до налаштувань',
  lbl_choose_account_type: 'Оберіть тип акаунту',
  lbl_confirmation: 'Підтвердження',
  lbl_to_dashboard: 'На головну',
  // limits_view
  lim_limits: 'Ліміти',
  lim_limits_requests: 'Список запитів',
  lim_imposed_on: 'Введений по відношенню',
  lim_one_time: 'Одноразовий ліміт',
  lim_daily: 'Денний ліміт',
  lim_weekly: 'Тижневий ліміт',
  lim_monthly: 'Місячний ліміт',
  lim_annual: 'Річний ліміт',
  lim_daily_left: 'Денний лімітний залишок:',
  lim_weekly_left: 'Тижневий лімітний залишок:',
  lim_monthly_left: 'Місячний лімітний залишок:',
  lim_annual_left: 'Річний лімітний залишок:',
  lim_left_total: '(Використано/усього)',
  lim_upload_poi: 'Завантажити підтвердження доходу',
  lim_poi: 'Підтвердження доходу',
  lim_requested: 'Запит успішно надіслано',
  lim_date: 'Дата',
  lim_request_id: 'ID запиту',
  lim_state: 'Статус',
  lim_asset: 'Актив',
  lim_proof: 'Підтвердження доходу',
  lim_heading: 'Ліміти, введені по відношенню до облікового запису',
  lim_left: 'Залишилось',
  lim_total: 'Усього',
  lim_spent: 'Витрачено',
  lim_change_limits: 'Змінити ліміти',
  lim_change_limits_title: 'Змінити ліміти - %{assetName} (%{asset})',
  lim_no_changing_requests: 'Немає запитів на зміну лімітів',
  lim_no_changing_requests_desc: 'Тут буде відображений список ваших запитів на зміну лімітів',
  lim_transaction_type_title: 'Тип транзакції',
  lim_requirements_title: 'Вимоги',
  lim_pending_request_msg: 'Ваш запит очікує розгляду адміністратором',
  lim_upload_documents_btn: 'Завантажити документи',
  lim_operation_type_limit_label: 'Обрати тип ліміту',
  limit_daily_validation_msg: 'Будь ласка, встановіть денний ліміт',
  limit_weekly_validation_msg: 'Будь ласка, встановіть тижневий ліміт',
  limit_monthly_validation_msg: 'Будь ласка, встановіть місячний ліміт',
  limit_validation_msg: 'Будь ласка, встановіть ліміти',
  limit_daily_fall_behind_msg: 'Денний ліміт не може бути нижче 0',
  limit_weekly_fall_behind_msg: 'Тижневий ліміт не може бути нижче 0',
  limit_monthly_fall_behind_msg: 'Місячний ліміт не може бути нижче 0',
  limit_annual_fall_behind_msg: 'Річний ліміт не може бути нижче 0',
  limit_monthly_exceed_msg: 'Місячний ліміт не може перевищувати річний ліміт',
  limit_weekly_exceed_msg: 'Тижневий ліміт не може перевищувати місячний ліміт',
  limit_daily_exceed_msg: 'Денний ліміт не може перевищувати тижневий ліміт',
  lim_transaction_type: 'Тип транзакції',
  lim_requirements: 'Вимоги',
  lim_withdrawal_daily_msg1: 'УВАГА! Сума платежу не може перевищувати %{limit} %{asset}.',
  lim_withdrawal_daily_msg2: 'Загальна сума за робочий (банківський) день не може перевищувати %{limit} %{asset}.',
  lim_withdrawal_daily_msg3: 'Святкові та вихідні дні вважаються як єдиний банківський день з наступним робочим днем.',
  // login_view
  log_signin: 'Увійти',
  log_dont_have_an_account: 'У вас немає облікового запису?',
  log_register_now: 'Зареєструватися зараз',
  log_forgot_password: 'Забули пароль?',
  log_recover_it: 'Відновити',
  // modals
  mod_pwd_wrond: 'Неправильний пароль',
  mod_pwd_required: 'Введіть поточний пароль',
  mod_tfa_required: 'Необхідна 2-х факторна аутентификація',
  mod_save_seed: 'Це ваша seed-фраза.',
  mod_save_seed_subtitle: 'Вона знадобиться для відновлення доступу, якщо ви забудете або загубите пароль. Обов\'язково збережіть seed-фразу в надійному місці.',
  mod_why_save_seed: 'Для безпеки, будь ласка, збережіть цей код у секретному місці.\nВін знадобиться вам для відновлення доступу до вашого облікового запису.',
  mod_validate_seed_how: 'Будь ласка, скопіюйте її так само як у полі нижче:',
  mod_confirm_title: 'Ви впевнені?',
  mod_withdrawal_confirm_title: 'Ви впевнені, що хочете відмінити транзакцію виведення?',
  mod_withdrawal_confirm_message: 'Кошти буде повернуто на баланс.',
  mod_confirm_message: 'Перед тим, як продовжити, будь ласка, підтвердіть цю дію',
  mod_confirm_confirm_text: 'Підтверджую',
  mod_confirm_cancel_text: 'Закрити',
  mod_email_not_verified_title: 'Email не підтверджений',
  mod_email_not_verified_message: 'Схоже, що ваш email ще не підтверждений. Будь ласка, перевірте папку "Спам" або запросіть новий лист, нажавши "Підтверждую"',
  mod_accountBlocked_title: 'Обліковий запис заблокований',
  mod_accountBlocked_message: 'Ви більше не можете проводити транзакції',
  mod_under_construct_title: 'Ця сторінка тимчасово знаходиться в розробці',
  mod_under_construct_text: 'Якщо у вас виникли якісь питання, напишіть у підтримку — ми допоможемо вирішити ваши проблеми.',
  mod_empty_fund_logo: 'Додайте логотип або відео для прев\'ю вашого проєкту',
  mod_empty_fund_description: 'Додайте опис проєкту',
  mod_empty_token_logo: 'Додайте логотип вашого активу',
  mod_confirm_seed: 'Ваш акаунт заблоковано. Ви не зможете виконувати операції. Будь ласка, введіть Seed-фразу для розблокування вашого акаунту.',
  mod_confirm_seed_login: 'Ваш акаунт заблоковано. Будь ласка, введіть Seed-фразу для розблокування вашого акаунту.',
  // sale_view
  sale_enable_time_spec: 'Указувати дату і час',
  sale_start_time: 'Дата початку',
  sale_start_time_now: 'Після підтвердження',
  sale_start_time_set: 'Указати дату',
  sale_close_time: 'Дата фінішу',
  sale_close_time_manual: 'Можливість закрити до датт фінішу',
  sale_soft_cap_with_asset: 'Мінімальний поріг (%{asset})',
  sale_soft_cap: 'Soft cap',
  sale_hard_cap_with_asset: 'Максимальний поріг (%{asset})',
  sale_hard_cap: 'Hard cap',
  sale_base_asset_for_hard_cap: 'Базовий актив для досягнення максимального порогу',
  sale_base_asset_hard_cap_to_sell: '%{asset} для продажу',
  sale_provide_information: 'Надайте інформацію про проєкт',
  sale_description_step: 'Опис',
  sale_next_step: 'Наступний крок',
  sale_short_blurb: 'Коротка реклама',
  sale_description_label: 'Опис (до 250 символів)',
  sale_full_description: 'Повний опис',
  sale_tell_about_fund: 'Розкажіть людям про ваш проєкт',
  sale_project_information: 'Введіть інформацію про проєкт',
  sale_create_sale: 'Створити проєкт',
  sale_in_process_of_creation: 'У процесі створення',
  sale_open_requests: 'Запити на відкриття проєкту',
  sale_start_new_sale: 'Почати новий проєкт',
  sale_quote_assets: 'Приймати інвестиції у:',
  sale_confirm: 'Будь ласка, підтвердіть намір створення проєкту',
  sale_get_asset: 'У %{asset}',
  sale_invest_asset: 'Інвестувати %{asset}',
  sale_offer_created: 'Інвестування пройшло успішно. %{asset} буде доданий до вашого гаманця, коли проєкт буде успішно завершений.',
  sale_offer_cancelled: 'Ваша інвестиція у %{asset} закрита успішно.',
  sale_offer_cancel: 'Закрити пропозицію',
  sale_offer_cancel_tip: 'Поточна сума інвестиції: %{amount} %{asset}',
  sale_token_sale_agreement: 'Переглянути угоду актива проєкта',
  sale_by_owner: 'продавець %{owner}',
  sale_invest: 'Інвестувати',
  sale_investing: 'Інвестуючи',
  sale_tip: 'Активи будуть випущені тільки коли ціль проєкту досягне %{endTime}',
  sale_corporate_details: 'Корпоративні деталі',
  sale_crowdfund_team: 'Команда збору коштів',
  sale_crowdfund_leader: 'Лідер збору коштів',
  sale_accept_investments: 'Будь ласка, обіріть актив(и), в яких ви приймаєте інвестиції',
  sale_disable_invest_owners: 'Власник проєкту не може інвестувати в свої проєкти',
  sale_disable_invest_hardcap_exceed: 'Сума інвестицій досягла максимального порогу: %{amount}',
  sale_disable_invest_upcoming_sale: 'Непочаті проєкти не підлягають інвестуванню',
  sale_disable_invest_closed_sale: 'Закриті проєкти не підлягають інвестуванню',
  sale_disable_invest_canceled_sale: 'Закриті проєкти не підлягають інвестуванню',
  sale_state: 'Статус проєкту',
  sale_not_available_exp: 'Створювати проєкти можуть тільки корпоративні користувачі. Пройдіть, будь ласка, верифікацію.',
  sale_nothing_found: 'Нічого не знайдено',
  sale_no_created_sales: 'Ви ще не створили жодного проєкту.',
  sale_create_request_success: 'Інформація завантажена. Будь ласка, дочекайтесь підтвердження.',
  sale_offer_overlap: 'При створенні нової пропозиції попередня пропозиція буде оновлена',
  sale_max_invest: 'Установіть максимальну суму для інвестування',
  sale_creation_requests: 'Запити на створення проєкту',
  sale_no_creation_requests: 'Немає запитів на створення проєкту',
  sale_no_creation_requests_desc: 'Тут буде список ваших запитів на створення проєктів',
  sale_short_description: 'Короткий опис',
  sale_fund_video: 'Відео про проєкт',
  sale_investments: 'Інвестиції',
  sale_investment_history: 'Історія інвестицій',
  sale_company_status_active: 'Активний',
  sale_company_status_completed: 'Завершений',
  sale_company_info: 'Інформация про проєкт',
  sale_collected: 'Зібрано',
  sale_purpose_collection: 'Ціль збору',
  sale_remains_to_collect: 'Залишилось зібрати',
  sale_until_the_end: 'До завершення проєкту',
  sale_campaign_type: 'Тип проєкту',
  sale_sales_share: 'Доля продажу',
  sale_profitability: 'Прибутковість',
  sale_fixed_annual_arrive: 'Фіксований річний прибуток',
  sale_campaign_duration: 'Термін проєкту',
  sale_minimum_investment: 'Мінімальна інвестиція',
  sale_confirm_upload_ttl: 'Важливо',
  sale_confirm_upload: 'Будь ласка, переконайтесь, що ваш документ актуальний та дійсний. Він буде загальнодоступним, і будь-який користувач зможе його завантажити. У разі необхідності документи можуть бути видалені.',
  sale_upload_success: 'Документ успішно завантажено',
  sale_doc_tab_title_is_my: 'Діючі юридичні документи зміцнюють довіру інвесторів до вашого проєкту.',
  sale_doc_tab_docs_is_my: 'Тут буде відображено список завантажених документів',
  sale_upd_tab_add_update: 'Додайте оновлення до графіку',
  sale_upd_tab_add_timeline: 'Додайте замітку до графику',
  sale_upd_tab_share_updates: 'Поділіться оновленнями за своїми спонсорами і потенційними інвесторами!',
  sale_upd_tab_important_updated: 'Важливі оновлення будуть відображені тут',
  sale_upd_tab_warning: 'Ви не зможете відредагувати або видалити оновлення пізніше',
  sale_new_update: 'Нове оновлення',
  sale_investor_income: 'Прибуток інвестора',
  sale_project_name: 'Інвестиційний проєкт',
  sale_limit_exceeded: 'Ліміт перевищено',
  sale_tab_overview: 'Опис',
  sale_tab_details: 'Деталі',
  sale_tab_token: 'Актив',
  sale_tab_video: 'Відео',
  sale_tab_updates: 'Оновлення',
  sale_tab_documents: 'Документи',
  sale_tab_dividends: 'Дивіденди',
  sale_pay_dividends: 'Виплатити дивіденди',
  sale_payout_amount: 'Сума виплати',
  sale_token_holder: 'Власник активу',
  sale_balance: 'Баланс',
  sale_dividends: 'Дивіденди',
  sale_dividends_confirm_title: 'Виплатити дивіденди?',
  sale_dividends_confirm_text: 'Підтвердіть переказ дивідендів відібраним отримувачам на загальну суму %{amount} EUR.',
  sale_dividends_confirm_bt_confirm: 'Підтвердити',
  sale_dividends_confirm_bt_cancel: 'Скасувати',
  sale_dividends_search_placeholder: 'Пошук за електронною поштою ...',
  sale_type_fund: 'Тип проєкту',
  sale_publication: 'Публікація',
  sale_choose_fund_type: 'Оберіть тип проєкту',
  sale_choose_fund_subtype: 'Інвестиційний підтип',
  sale_type_crowdinvesting: 'Краудінвестинговий',
  sale_type_crowdfunding: 'Краудфандинговий',
  sale_type_description: 'Підійде вам, якщо ви зібрались розводити кроликів і хочете зібрати на це визначену суму',
  sale_type_description_investing: 'У вас серйозний проєкт, який потребує додаткових інвестицій для розвитку',
  sale_subtype_description: 'Інвестори повертають свої внески + фіксований річний відсоток. Виплати не залежать від вашого прибутку.',
  sale_subtype_description_equity: 'Класична інвесторна система, де розмір виплачуваних дивідендів залежить від вашого доходу.',
  sale_progress_value: 'Заповнено на %{progress}%',
  sale_subtype_deposit: 'Займ',
  sale_subtype_equity: 'Власний капітал',
  sale_subtype_crowdfunding: 'Краудфандинг',
  sale_year_earn: 'Фіксований річний прибуток',
  sale_payout_frequency: 'Періодичність виплат',
  sale_payout_frequency_divid: 'Періодичність виплат дивідендів',
  sale_loan_term: 'Термін проєкту, місяці',
  sale_equity_reporting: 'Періодичність фінансовой звітності',
  sale_start: 'Початок',
  sale_finish: 'Кінець',
  sale_term_control: 'Термін управління активом',
  sale_term_control_description: 'Після початку терміну інвестори мають право вимагати у вас повернення тіла інвестиції.',
  sale_term_control_description_2: 'Наприкінці терміну ви зобов\'язані повернути тіло інвестиції всім інвесторам.',
  sale_early_exit: 'Умови раннього виходу — ставка дисконтування',
  sale_recipient_email: 'Пошта отримувача',
  sale_deduction_percentage: 'Відсоток відчислення',
  sale_add_more_recipient: 'Додати ще',
  sale_campaign_settings: 'Налаштування проєкту',
  sale_your_fund_type: 'Тип вашого проєкту',
  sale_campaign_start: 'Старт проєкту',
  sale_campaign_finish: 'Фініш проєкту',
  sale_campaign_time_description: 'Ми рекомендуємо зазначати термін проєкту не менше 2-3 тижнів - так його побачать більше інвесторів',
  sale_investment_asset: 'Актив збору інвестицій',
  sale_softcap_description: 'Soft cap — мінімальній поріг інвестицій, якого повинен досягнути ваш проєкт.',
  sale_hardcap_description: 'Hard cap — максимальний поріг інвестицій, при його досягненні проєкт завершується автоматично.',
  sale_collection_amount: 'Сума збору',
  sale_available_currencies: 'Доступні активи для інвестиції',
  sale_available_currencies_description: 'Оберіть, у якому активі користувачі зможуть інвестувати у ваш проєкт.',
  sale_available_currencies_description_2: 'Ми автоматично конвертуємо суму інвестицій. Наприклад, якщо ви обрали USD як основний актив для збору, а інвестор бажає проінвестувати у EUR, ми автоматично сконвертуємо його інвестицію в USD, виходячи з поточного курсу.',
  sale_create_token: 'Створення активу',
  sale_token_logo_title: 'Логотип активу',
  sale_name_token_title: 'Придумайте назву активу',
  sale_my_token: 'Мій актив',
  sale_token_code_title: 'Задайте унікальный код активу',
  sale_token_code_description: '— від 3 до 5 символів',
  sale_token_code_description_2: ' — тільки латиниця і цифри',
  sale_token_for_sale: 'Кількість активів для продажу',
  sale_campaign_name: 'Придумайте назву для проєкту',
  sale_campaign_name_label: 'Мій проєкт',
  sale_campaign_preview: 'Прев\'ю проєкту',
  sale_campaign_description: 'Опис проєкту',
  sale_add_video: 'Додайте відео про проєкт',
  sale_add_video_label: 'Посилання на YouTube',
  sale_add_button: 'Оберіть файл',
  sale_publication_text_1: 'Ваш проєкт готовий до публікації, нам тільки залишилось перевірити його.',
  sale_publication_text_2: 'Ви можете повернутись на будь-який крок і перевірити внесені дані.',
  sale_publication_text_3: 'Після підтвердження проєкту администратором ви не зможете змінити дані, тож ми рекомендуємо все перевірити ще раз. Про всяк випадок.',
  sale_publication_confirm: 'Відправити на перевірку',
  sale_crowdfunding: 'Краудфандинг',
  sale_deposit: 'Краудінвестинг - Займ',
  sale_equity: 'Краудінвестинг - Власний капітал',
  sale_video_title: 'Додайте посилання на відео, яке стане прев\'ю вашого проєкту',
  sale_video_preview_error: 'Некоректне посилання на відео',
  sale_video_formats: 'Підтримувані сервисі: YouTube',
  sale_video_past: 'Вставте посилання сюди',
  sale_publication_btn: 'Публікація проєкту',
  sale_period_month: 'Місяць',
  sale_period_quarter: 'Квартал',
  sale_period_half_year: 'Півріччя',
  sale_period_year: 'Рік',
  sale_status_title: 'Дуже добре! Ми вже перевіряємо ваш проєкт',
  sale_status_text_accent: 'Ви можете відстежувати статус вашої заявки в розділі «Мої проєкти»',
  sale_status_text: 'Якщо ви обрали дату старту після підтверждення, ми опублікуємо проєкт одразу після перевірки.',
  sale_interest_description: 'Відсоток прибутковості залежить від суми прибутку Емітента.',
  sale_interest_from: 'від',
  sale_interest_to: 'до',
  sale_interest_profitability: 'Прибутковість',
  sale_to_end: '%{days} дні(ів) залишилось',
  sale_ends_today: 'Закінчується сьогодні',
  sale_minimum_invest: 'Мінімальна сума інвестиції',
  sale_set_min_invest: 'Задайте мінімальну суму, яку хочете приймати від інвесторів.',
  sale_back_to_list: 'Повернутися до списку',
  sale_add_video_bt: 'Додати відео',
  sale_add_update_bt: 'Додати оновлення',
  sale_upload_document_bt: 'Завантажити документ',
  sale_tab_documents_ismy_header: 'Тут будуть ваші документи, які відносяться до проєкту',
  sale_tab_documents_ismy_text: 'Інвестори цінують прозорість — діліться з ними фінансовими звітами, стратегією розвитку та іншими важливими документами.',
  sale_tab_updates_ismy_header: 'Тут будуть ваші нотатки про оновлення проєкту',
  sale_tab_updates_ismy_text: 'Розкажіть вашими інвесторам про новини проєкту — на якій він стадії, чи потребуєте ви допомоги або просто подякуйте їх за участь.',
  sale_add_note_bt: 'Додати запис',
  sale_video_empty_header: 'Тут буде відображено список завантажених відео',
  sale_invested_header: 'Ваша сума інвестиції',
  sale_invested_closed_text: 'Інвестиції в закритий проєкт не приймаються',
  sale_invested_amount_text: 'Ваша сума інвестиції',
  sale_invested_change_amount_bt: 'Змінити суму інвестиції',
  sale_invested_cancel_bt: 'Відмінити інвестицію',
  sale_invested_block_header: 'Інвестування',
  sale_invested_your_balance: 'Ваш баланс',
  sale_invested_your_profit: 'Ваш прибуток складає',
  sale_invested_is_upcoming: 'Не стартувавші проєкти не підлягають інвестуванню',
  sale_invested_hard_cap_exceeded: 'Сума інвестицій досягла максимального порогу',
  sale_invested_is_closed: 'Закриття проєкту не підлягають інвестуванню',
  sale_invested_is_canceled: 'Закриті проєкти не підлягають інвестуванню',
  sale_invested_limit_exceeded: 'Перевищено ліміт',
  sale_profit_from_to: 'від %{from} до %{to}',
  sale_updates_header: 'Заголовок',
  sale_updates_textarea_label: 'Основний текст',
  sale_updates_textarea_placeholder: 'Розкажіть детальніше про свої досягнення або новини проєкту',
  sale_updates_add_note_bt: 'Додати запис',
  sale_updates_add_note_text: 'Опубліковані записи неможливо редагувати або видаляти — перевірте все перед публікацією',
  sale_updates_empty_header: 'Маєте новини про проєкт?',
  sale_updates_empty_text: 'Поділіться ними з інвесторами',
  // settings_view
  set_header: 'Налаштування',
  set_logout: 'Вийти з акаунту',
  set_dialog_title: 'Ви дійсно бажаєте вийти зі свого акаунту?',
  set_dialog_content: 'Ми залишимось тут і будемо чекати на вас!',
  set_bt_confirm: 'Вийти з акаунту',
  set_bt_cancel: 'Відмінити',
  set_account: 'Обліковий запис',
  set_keys: 'Ключі',
  set_withdraw: 'Вивід',
  set_security: 'Безпека',
  set_verify_account: 'Верифікація',
  set_account_id: 'ID облікового запису',
  set_secret_seed: 'Приватний ключ',
  set_copy_secret_seed: 'Скопіювати приватний ключ',
  set_your_account_id: 'ID вашого облікового запису',
  set_change_password: 'Змінити пароль',
  set_change_uplata_insha: 'Карти Visa Iнша',
  set_change_taid: 'Карти UPLATA',
  set_provide_pwd: 'Введіть новий пароль',
  set_help_pwd: 'Надійний пароль допомагає запобігти несанкціонованому доступу до вашого облікового запису',
  set_pwd_do_not_match: 'Паролі не співпадають',
  set_pwd_changed: 'Пароль змінено',
  set_tfa: '2-х факторна аутентифікація',
  set_tfa_enable: 'Включити 2-х факторну аутентифікацію',
  set_tfa_copy_code: 'Сканувати код 2-х факторної аутентифікації',
  set_tfa_scan_the_qr_code: 'Сканувати QR-код за допомогою додатку 2FA',
  set_or_manually_enter: 'або введіть секретний код вручну',
  set_paste_tfa_code: 'Надайте ',
  set_seed_description: 'Приватний ключ - це особиста інформація, яка підтверджує, що ви - власник свого облікового запису.',
  set_uplata_insha_added: 'Visa Iнша карта додана',
  set_uplata_insha_changed: 'Параметри автовиводу Visa Iнша змінено',
  set_uplata_insha_deleted: 'Visa Iнша карта видалена',
  set_confirm_autowithdraw_change: 'Автовивід дозволено лише для однієї карти. \nВідключити автовивід для %{name} id="%{id}"?',
  set_taid_added: 'UPLATA карта додана',
  set_taid_changed: 'Параметри автовиводу UPLATA змінено',
  set_taid_deleted: 'UPLATA карта видалена',
  set_cards_changed: 'Параметри автовиводу змінено',
  set_my_cards: 'Мої карти',
  set_change_xpay: 'Платіжні карти',
  // signup_view
  su_email: 'Email',
  su_pwd: 'Пароль',
  su_confirm: 'Підтвердіть пароль',
  su_already_have_an_account: 'У вас вже є акаунт?',
  su_sign_in: 'Увійти зараз',
  su_sign_up: 'Зареєструватися',
  chart_assets: 'Активи',
  su_documents_text: 'Натискаючи кнопку ЗАРЕЄСТРУАТИСЬ, ви приймаєте',
  su_documents_user_agreement: 'Угода користувача,',
  su_documents_terms_service: 'Умови використання,',
  su_documents_privacy_policy: 'Політика конфіденційності',
  // trade_view
  trd_want: 'Хочу',
  trd_order: 'Продаю',
  trd_base: 'Базовий',
  trd_quote: 'Другий',
  trd_price: 'Ціна',
  trd_created: 'Створено',
  trd_ask: 'Купівля',
  trd_bid: 'Продаж',
  trd_offer_canceled: 'Пропозицію успішно скасовано',
  trd_offer_created: 'Пропозицію успішно створено',
  trd_offer_failed_to_cancel: 'Не вдалось скасувати пропозицію',
  trd_order_not_enough_funds: 'Недостатньо коштів!',
  trd_some_went_wrong: 'Щось пішло не так...',
  trd_no_trade_history: 'Немає історії торгів',
  trd_no_orders_history: 'Немає заявок',
  trd_here_will_be_the_list: 'Список виконаних запитів',
  trd_here_will_be_the_order_list: 'Список поточних запитів',
  trd_here_will_be_the_order_ask_list: 'Тут буде список поточних запитів',
  trd_here_will_be_the_order_bid_list: 'Тут буде список поточних бідів',
  trd_validate_minimal_price: 'Ціна повинна бути більше %{value}',
  trd_validate_minimal_amount: 'Мінімальна сума складає %{value}',
  trd_price_per: 'Ціна за 1 %{asset}',
  trd_amount_for: 'Сума %{asset}',
  trd_total_value: 'Усього %{value}',
  trd_total_sell: 'Хочу продати %{asset}',
  trd_will_receive: 'Отримаю %{value}',
  trd_create_sell_order: 'Створити заявку на продаж %{value}',
  trd_create_buy_order: 'Створити заявку на купівлю %{value}',
  trd_history: 'Історія торгів',
  trd_history_amount: 'Сума (%{asset})',
  trd_history_price: 'Ціна (%{asset})',
  trd_history_total: 'Усього (%{asset})',
  trd_history_time: 'Час',
  trd_manage: 'Ваші відкриті %{pair} заявки',
  trd_manage_date: 'Дата',
  trd_manage_market: 'Ринок',
  trd_manage_order: 'Заявка',
  trd_order_wdrawal: 'Заявлена сума',
  trd_manage_base_asset_amount: 'Кількість базового активу',
  trd_manage_quote_asset_price: 'Ціна в другому активі',
  search_campaign: 'Пошук краудфандингових проєктів',
  trd_order_buy: 'Купити',
  trd_order_sell: 'Продати',
  trd_market_price: 'Риночна ціна',
  trd_since_last: 'починаючи з останнього %{value}',
  trd_chart_hour: 'Час',
  trd_chart_day: 'День',
  trd_chart_month: 'Місяць',
  trd_chart_year: 'Рік',
  trd_orders: 'Відкриті заявки',
  trd_confirm_match: 'Натиснувши "Підтвердити", ви створюєте заявку, протилежну обранній',
  trd_no_pairs: 'Немає торгових пар',
  trd_no_pairs_exp: 'Ця функція буде доступна після появи будь-якої торговой пари',
  trd_no_exchange_pairs: 'Немає зареєстрованих торгових пар, доступних для конвертації валют',
  trd_no_exchange_pairs_exp: 'Ця функція буде доступна після появи торговой пари',
  trd_load_rates_failed: 'Помилка при читанні курсів для %{source}',
  trd_balance: 'Ваш баланс %{base}/%{quote}',
  // transfers_view
  tr_send: 'Надіслати',
  tr_confirm: 'Підтвердження платежу',
  tr_operation_confirm: 'Підтвердження операції',
  tr_recipient_not_found: 'Отримувача не знайдено',
  tr_pay_fee_for_rec: 'Сплатити коміссію замість отримувача',
  tr_successful: 'Платіж здійснено успішно',
  tr_no_assets: 'У вашому гаманці немає торгових активів',
  tr_no_assets_exp: 'Ця функція буде доступна, як тільки у вас з\'явиться будь-який актив із можливістю передачі',
  tr_no_assets_exists: 'У системі не існує активів',
  tr_no_assets_exists_exp: 'Ця функція буде доступна, як тільки з\'явиться будь-який актив',
  tr_balance: 'Ваш баланс %{balance} %{token}',
  tr_create_mass: 'Створити масовий переказ',
  tr_mass_about: 'Завантажте .csv файл, в якому містяться електронна пошта або ID користувача, сума і актив переказу. Інформація для кожного отримувача вказується в новій строці.',
  tr_tell_me_more: 'Хочу знати більше',
  tr_about_csv: 'Приклад файлу csv',
  tr_how_to_create_csv: 'Як створити .CSV файл',
  tr_mass_about_detailed: 'У форматі CSV поля даних поділяються комою. Тут ви можете скачати приклад таблиці:',
  tr_should_look_like: 'повинно виглядати так:',
  tr_use_editor: 'Також ви можете експортувати .csv із текстових редакторів (наприклад, Notepad, Microsoft Excel, OpenOffice Calc або Google Docs)',
  tr_total_amount: 'Загальна сума',
  tr_total_source_fee: 'Загальна сума комісії відправника',
  tr_total_recipient_fee: 'Загальна сума комісії отримувача',
  tr_mass_payment_details: 'Ваша сплата становить:',
  tr_mass_payment_failed: 'Одна або декілька операцій недійсні. Будь ласка, перегляньте їх та спробуйте ще раз',
  tr_current_recipient_not_found: 'отримувач %{recipient} не знайдений',
  tr_less_than_fee: 'Сума, яку ви надсилаєте, менше встановленої системної комісії',
  tr_greater_than_balance: 'Сума, яку ви надсилаєте, перевищує баланс',
  tr_sending_error: 'Помилка відправки',
  tr_transfer_balance: 'Баланс %{amount} %{asset}.',
  tr_found_errors: 'Помилки',
  tr_not_valid_file: 'Операція неуспішна, дані завантаженого файлу невірні',
  tr_digital_values: 'Цифрові номінали',
  tr_no_digital_values: 'Немає в наявності',
  tr_digital_values_for: 'за',
  tr_conformation_buing_sertificate: 'Ви дійсно бажаєте купити сертифікат номіналом %{amountX} %{currencyX} за %{amountY} %{currencyY}?',
  tr_greater_amount_and_commissions: 'Сума разом з комісіями, яку ви надсилаєте, перевищує баланс',
  // tx-history_view
  th_transaction_history: 'Історія транзакцій',
  th_failed_to_load_tx: 'Не вдалось завантажити історію',
  th_no_transaction_history: 'Ви поки що не зробили жодної транзакції',
  th_here_will_be_the_list: 'Тут буде відображено список ваших транзакцій',
  th_no_transaction_history_search: 'Спробуйте пошукати по іншим активам або ',
  th_no_transaction_history_search_end: ', якщо у вас є питання',
  th_no_assets_in_your_wallet: 'У вашому гаманці немає активів',
  th_no_balances_in_your_wallet: 'У вашому гаманці немає активів для обміну',
  th_no_currencies_in_your_wallet: 'У вашому гаманці немає активів для конвертації',
  th_here_will_be_tokens: 'Тут буде відображено список ваших активів',
  th_sub: 'Добавити',
  th_export_btn: 'Експорт',
  th_export_popup_title: 'Експорт транзакцій',
  th_export_popup_text: 'Виберіть потрібні фільтри',
  // verification_view
  kyc_i_agree: 'Я підтверждую, що ознайомився з <a @click.stop.prevent>Угодою користувача</a> и <a @click.stop.prevent>Політикою конфіденційності</a>, а також те, що мені вже виповнилось 18 років.',
  kyc_account_verification: 'Верифікація облікового запису',
  kyc_data_processed: 'Ваші дані проходять обробку',
  kyc_address_details: 'Подробиці адреси',
  kyc_required_documents: 'Необхідні документи',
  kyc_document_not_attached: 'документ не прикріплений',
  kyc_photo_verification: 'Фото верифікація',
  kyc_photo_explain: 'Для того, щоб ми знали, що це саме ви надаєте документи, будь ласка, зробіть фото з унікальним згенерированим кодом',
  kyc_show_key: 'Показати ключ',
  kyc_verification_key: 'Ключ підтверждення',
  kyc_not_all_docs: 'Будь ласка, завантажте всі документи перед відправкою',
  kyc_upload_success: 'Інформація заватажена. Будь ласка, дочекайтесь підтвердження',
  kyc_current_account_state: 'Поточний статус облікового запису',
  kyc_approved_msg: 'Ваш акаунт схвалено. Усі дії, які потребують верифікації, тепер доступні',
  kyc_approved_syndicate: 'Ваш акаунт схвалено, ви - корпоративний користувач. Усі дії, які потребують верифікації, тепер доступні',
  kyc_waiting_msg: 'Ваш запит на верифікацію надіслано. Будь ласка, дочекайтесь, поки інформація буде розглянута.\nВи зможете оновити деталі після розгляду запиту',
  kyc_rejected_msg: 'На жаль, ваш обліковий запис був відхилений через: %{reason}',
  kyc_personal_details: 'Персональні подробиці',
  kyc_corporate_details: 'Корпоративні подробиці',
  kyc_documents: 'Документи',
  kyc_approved_title: 'Обліковий запис підтверджено. <br>Ви зареєстровані як %{account_type}.',
  kyc_update: 'ОНОВИТИ ДАНІ ВЕРИФІКАЦІЇ',
  kyc_general: 'Фізична особа',
  kyc_submit: 'Пройти верифікацію',
  kyc_pass: 'Пройти верифікацію',
  kyc_check_status: 'Перевітири статус верифікації',
  kyc_corporate: 'Юридична особа',
  kyc_inv_tip: 'Може інвестувати в проєкти',
  kyc_corporate_tip: 'Може створювати проєкти',
  kyc_rejected_title: 'Ваш запит на верифікацію відхилено',
  kyc_rejected_msg_html: 'На жаль, верифікацію вашого облікового запису було відхилено через: <span class="reject-message">%{reason}</span>',
  kyc_not_privacy_policy: 'Будь ласка, прийміть Політику конфіденційності перед відправкою',
  kyc_form_submit: 'Відправка форми для проходження процедури верифікації',
  kyc_general_company_information: 'Загальна інформація про компанію',
  kyc_company_legal_address: 'Юридична адреса компанії',
  kyc_business_model: 'Бізнес-модель',
  kyc_company_documents: 'Документи компанії',
  kyc_company_directors: 'Директори і акціонери',
  kyc_residence_address: 'Деталі адреси проживання',
  kyc_address_proof: 'Документ, підтверджуючий адресу',
  kyc_submit_company_documents: 'Надати документи компанії',
  kyc_upload_memorandium: 'Завантажте сканкопію Меморандуму і Статуту',
  kyc_upload_signatories: 'Завантажте сканкопію авторизації підписантів компанії',
  kyc_upload_chart: 'Завантажте файл з організаційною структурою компанії',
  kyc_upload_address: 'Завантажте сканкопію документу, який підтверджує адресу',
  kyc_upload_id: 'Завантажте сканкопію документу, який підтверджує особистість',
  kyc_upload_certificate_of_shareholders: 'Завантажте сканкопію Сертификату акціонерів і директорів',
  kyc_upload_annual_report: 'Завантажте сканкопію останнього річного звіту компанії',
  kyc_upload_origination_certificate: 'Завантажте сканкопію Свідоцтва про реєстрацію',
  kyc_company_industry: 'Галузь компанії',
  kyc_company_website: 'Вебсайт компанії',
  kyc_company_phone: 'Номер телефону компанії',
  kyc_corp_step1_subhead: 'Усі документи, крім опису бізнес-моделі, організаційної структури і вебсайту компанії, повинні бути нотаріально завірені посадовою особою, призначенною місцевим урядом. Ця особа виступає в якості неупередженого свідка різних офіційних мір протидії шахрайству, пов\'язаних із підписом важливих документів.',
  kyc_submit_legal_address: 'Будь ласка, підтвердіть наступну інформацію про юридичну адресу',
  kyc_upload_audited_copy: 'Завантажте завірену копію, якщо це можливо. Якщо це неможливо, завантажте останню виписку з банківського рахунку компанії. Банківська виписка потрібна для всіх компаній, які ведуть торгову діяльність менше ніж 12 місяців. Для більш крупних компаній потрібні податкові декларації за 3 попередні роки.',
  kyc_submit_full_kyc_docs: 'Надайте повний перелік документів, необхідних для проходження процедури верифікації всіх директорів і акціонерів компанії (якщо вони відрізняються і мають долю більше 10%)',
  kyc_submit_docs: 'Надайте документацію компанії(й)',
  kyc_submit_residence_address: 'Будь ласка, надайте наступну інформацію про місце проживання',
  kyc_upload_address_proof: 'Будь ласка, завантажте документ, який підтверджує адресу',
  kyc_upload_business_model: 'Завантажте файл із описом бізнес-моделі',
  kyc_submit_personal_information: 'Будь ласка, надайте наступну особисту інформацію',
  kyc_upload_one_of_docs: 'Будь ласка, завантажте один із документів:',
  kyc_upload_document_photo: 'Завантажте фото документу',
  kyc_id_docs_tip: 'Рукописні документи або документи іноземною мовою, які не можуть бути прочитані, тобто арабський або кирилиця, не будуть прийняті, якщо вони не перекладені і не завірені нотаріально',
  kyc_driver_license: 'Водійське посвідчення, якщо воно ще не завантажене на попередньому етапі',
  kyc_utility_bill: 'Актуальний рахунок за комунальні послуги (не пізніше 6 месяців)',
  kyc_bank_statement: 'Банківська виписка або виписка по кредитній картці (не пізніше 6 месяців)',
  kyc_bank_reference_letter: 'Банківський рекомендаційний лист (не пізніше 6 месяців)',
  kyc_signed_tenancy: 'Підписанний договір аренди',
  kyc_valid_passport: 'Дійсний паспорт',
  kyc_driving_license: 'Водійське посвідчення - повне, не тимчасове, з кольоровою фотографією',
  kyc_national_id: 'Дійсний національний документ посвідчення особи',
  kyc_copy_passport: 'Нотаріально завірена копія дійсного паспорту з зображенням',
  kyc_copy_driver_license: 'Нотаріально завірена копія водійського посвідчення з зображенням',
  kyc_copy_national_id: 'Нотаріально завірена копія дійсного національного документу посвідчення особи з зображенням',
  kyc_corporate_copy_current_tax: 'Нотаріально завірена копія податкової декларації за останні 12 місяців',
  kyc_corporate_copy_bank_statement: 'Нотаріально завірена копія виписки з банку або виписки по кредитній картці (не старше 3 місяців)',
  kyc_corporate_copy_utility_bill: 'Нотаріально завірена копія рахунку за комунальні послуги (не пізніше 3 месяців)',
  kyc_submit_document: 'Будь ласка, надайте наступні документи',
  kyc_document_details: 'Деталі документу',
  // verification_new
  verif_investor: 'Інвестор',
  verif_issuer: 'Емітент',
  verif_description_step1_issuer: 'Підійте вам, якщо ви бажаєте створювати проєкти, які потребують інвестування.',
  verif_description_step1_investor: 'Підійте вам, якщо ви бажаєте інвестувати та отримувати прибуток.',
  verif_description_step2: 'Система не зберігає ваші персональні дані — вони зберігаються на партнерських серверах, які надійно захищені.',
  verif_step3_title: 'Ми верифікували ваші дані, вам залишилось тільки підтвердити тип акаунту.',
  verif_your_acc: 'Ваш тип акаунту — ',
  verif_step3_descritption: 'Після підтвердження ви не зможете змінити тип акаунту. Якщо передумали — оберіть інший тип та пройдіть верифікацію спочатку.',
  verif_change_acc: 'Змінити тип акаунту',
  verif_success_investor_title: 'Чудово! Ми підтвердили ваш акаунт Інвестора',
  verif_success_issuer_title: 'Чудово! Ми підтвердили ваш акаунт Емітента',
  verif_success_investor_subtitle: 'Тепер ви можете поповнювати рахунок, інвестувати в проєкти і отримувати дивіденди.',
  verif_success_issuer_subtitle: 'Тепер ви можете створювати проєкти, залучати інвестиції і виплачувати дивіденди інвесторам.',
  verif_success_investor_text: 'Давайте пошукаємо цікаві проєкти для інвестування — ми впевнені, ви знайдете щось до душі',
  verif_success_issuer_text: 'Вже маєте ідею для проєкту? Так чого ж ми чекаємо, давайте створемо ваш перший проєкт!',
  // withdrawal_view
  withdraw_percent_fee: 'відсоткова комісія',
  withdraw_fixed_fee: 'фіксована комісія',
  withdraw_approve: 'Прийняти',
  withdraw_reject: 'Відмовити',
  withdraw_withdraw: 'Вивести',
  withdraw_withdraw_option: 'Оберіть спосіб виводу',
  withdraw_withdrawal: 'Вивід коштів',
  withdraw_details: 'Запит на вивід',
  withdraw_pending: 'Очікується',
  withdraw_created: 'Створений',
  withdraw_approved: 'Прийнятий',
  withdraw_cancelled: 'Відмінений',
  withdraw_rejected: 'Відхилений',
  withdraw_permanently_rejected: 'Відхилений назавжди',
  withdraw_confirm: 'Підтвердження виводу',
  withdraw_how_much: 'Мінімальна сума виводу: %{value} %{asset}. ',
  withdraw_network_fee: 'При виводі коштів може стягуватися комісія банку.',
  withdraw_insha_fee: 'Мінімальна сума виводу: 11.00 UAH. Комісія банку: 10.00 UAH',
  withdraw_eth_btc: 'Мінімальна сума виводу: %{value} %{asset}.',
  withdraw_ex_address: 'Вивід на зовнішню адресу',
  withdraw_to: 'Вивід на:',
  withdraw_cashbox: 'Вивід через касу',
  withdraw_ucash: 'UPLATA (ID %{taid})',
  withdraw_uplata_insha: 'Visa Iнша (%{uplataInsha})',
  withdraw_xpay: '%{name} (%{mask_pan})',
  withdraw_external: 'Адреса %{asset}',
  withdraw_nothere: 'Вивід неможливий',
  withdraw_success: 'Запит на вивід успішно створено',
  withdraw_error_is_trying_to_send_to_yourself: 'Відправник не може бути отримувачем! Перевірте коректність адреси',
  withdraw_error_invalid_address: 'Недійсна адреса гаманця',
  withdraw_error_insufficient_funds: 'Недостатньо коштів',
  withdraw_error_minimum_amount: 'Мінімальна сума складає %{value} %{asset}',
  withdraw_error_maximum_amount: 'Максимальна сума складає %{value} %{asset}',
  withdraw_no_withdrawals: 'Немає запитів',
  withdraw_no_withdrawals_desc: 'Тут буде відображатись список запитів на вивід коштів',
  withdraw_no_assets: 'У вашому гаманці немає активів, які можуть бути виведені',
  withdraw_no_assets_exp: 'Ця функція буде доступна, як тільки у вас буде актив, який можна вивести',
  withdraw_amount_round: 'Сума виводу буде округлена до %{amount} %{asset}',
  withdraw_reject_reason_prompt: 'Введіть причину відмови',
  withdraw_reject_reason_warn: 'Поле не повинно бути пустим',
  withdraw_request_approved: 'Запит на вивід схвалено',
  withdraw_request_rejected: 'Запит на вивід відхилено',
  withdraw_creation_date: 'Дата створення',
  withdraw_updating_date: 'Дата оновлення',
  withdraw_list_tooltip: 'Використовуйте подвійне клацання миші для того, щоб відкрити форму підтвердження.',
  withdraw_usdt_delay_msg: 'Після створення транзацкції, подбайте, будь ласка, про її статус на екрані списку транзакцій, можливе застосуання затримки',
  withdraw_usdt_tx_sent: 'Транзакцію відправлено',
  withdraw_usdt_tx_sent_automaticly: 'Транзакція була надіслана автоматично',
  withdraw_usdt_tx_cancelled: 'Транзакцію скасовано. Ваші кошти незабаром повернуться на ваш гаманець',
  withdraw_usdt_tx_cancelled_automaticly: 'Ви не встигли скасувати транзакцію. Транзакція була надіслана автоматично',
  validate_amount_number: 'Сума повинна бути додатним числом',
  valid_email_or_id: 'Тут повинен бути коректний email або id користувача',
  valid_secret_key: 'Тут повинен бути коректний секретний ключ',
  valid_account_id: 'Тут повинен бути коректний id акаунту користувача',
  valid_password_az: 'Пароль повинен містити символи a-z, A-Z и 0-9',
  invalid_phone_number: 'Неправильний номер телефону',
  invalid_wallet_address: 'Неправильна адреса гаманця',
  // notifications
  notification_transaction_income: 'Ви отримали новий платіж %{amount} %{asset} від %{sender_name} (%{sender_email})',
  notification_transaction_emission: 'Нова емісія у розмірі %{amount} %{asset}',
  notification_transaction_exchange: 'Ви успішно обміняли %{source_amount} %{source_asset} за %{amount} %{asset}',
  notification_contract_money_lock: 'Ваші кошти в розмірі %{amount} %{asset} були зарезервовані відповідно до інвойсу %{invoice_number} контракту %{contract_number}.',
  notification_no_new_notifications: 'Немає нових повідомлень!',
  notification_kyc_to_not_verified: 'Вас переведено в статус неверифікованого користувача',
  notification_kyc_approve: 'Ваш обліковий запис успішно верифікований',
  notification_kyc_reject: 'На жаль, ми не змогли верифікувати ваш обліковий запис. Будь ласка, подайте заявку ще раз, враховуючи наші рекомендації.',
  notif_success_copied: 'Ваш email скопійований успішно',
  notif_one_time_wallet_copied: 'Адреса одноразового гаманця скопійована успішно',

  contact_title: 'Напишіть нам',
  contact_text: 'Команда CryptoPort відповість на всі ваші запитання',
  contact_send: 'Відправити',
  contact_name: 'Ім\'я',
  contact_email: 'E-mail',
  contact_theme: 'Тема листа',
  contact_message: 'Повідомлення',
  contact_send_error: 'Схоже, щось пішло не так. Ваше повідомлення не вдалось відправити. Будь ласка, спробуйте ще раз пізніше.',
  contact_email_invalid: 'Невірний формат email',
  contact_empty_field: 'Поле обов\'язкове для заповнення',
  contact_success: 'Ваше повідомлення успішно відправлено',
  webshop_ticket_not_found: 'Ордер не знайдено!',
  // topup_view
  topup_refill: 'Поповнення балансу',
  topup_topup: 'Поповнити',
  topup_balance: 'Ваш баланс складає %{amount} %{asset}',
  topup_percent_fee: 'відсоткова комісія',
  topup_fixed_fee: 'фіксована комиссия',
  topup_approve: '6-Прийняти',
  topup_reject: '7-Відмовити',
  topup_withdraw: 'Оберіть спосіб поповнення',
  topup_withdrawal: 'Поповнення',
  topup_details: '10-Запит на поповнення',
  topup_pending: 'Очікується',
  topup_created: 'Створений',
  topup_approved: 'Прийнятий',
  topup_cancelled: 'Відмінений',
  topup_rejected: 'Відхилений',
  topup_permanently_rejected: 'Відхилений назавжди',
  topup_confirm: 'Підтвердження поповнення',
  topup_how_much: 'Мінімальна сума поповнення: %{value} %{asset}',
  topup_minimal: 'При поповненні балансу може стягуватись комісія банку',
  topup_crypto_minimal: 'Враховувайте, що при поповненні балансу з вас може стягуватись комісія системи.',
  topup_failed_get_address: 'Не вдалось отримати адресу.',
  topup_network_fee: 'Також врахуйте, що у додаток до суми поповнення буде стягнута комісія.',
  topup_ex_address: 'Поповнення з зовнішнього адресу',
  topup_to: 'Поповнення з:',
  topup_cashbox: 'Поповнення через касу',
  topup_ucash: 'UPLATA (ID %{taid})',
  topup_uplata_insha: 'Visa Iнша (%{uplataInsha})',
  topup_xpay: '%{name} (%{mask_pan})',
  topup_external: 'Адреса %{asset}',
  topup_add_xpay_card: 'Додайте платіжну карту',
  topup_nothere: 'Поповнення неможливе',
  topup_success: 'Запит на поповнення успішно створений',
  topup_request: 'Запит на поповнення',
  topup_error_is_trying_to_send_to_yourself: 'Відправник не може бути отримувачем! Перевірте коректність адреси.',
  topup_error_invalid_address: 'Недійсна адреса гаманця',
  topup_error_insufficient_funds: 'Недостатньо коштів',
  topup_error_minimum_amount: 'Мінімальна сума складає %{value} %{asset}',
  topup_error_maximum_amount: 'Максимальна сума складає %{value} %{asset}',
  topup_no_withdrawals: 'Немає запитів',
  topup_no_withdrawals_desc: 'Тут буде відображений список запитів на поповнення коштів',
  topup_no_assets: 'У вашому гаманці немає активів, які можуть бути виведені',
  topup_no_assets_exp: 'Ця функція буде доступна, як тільки у вас буде актив, який можна вивести',
  topup_amount_round: 'Сума буде округлена до %{amount} %{asset}',
  topup_reject_reason_prompt: 'Введіть причину відмови',
  topup_reject_reason_warn: 'Поле не повинно бути пустим',
  topup_request_approved: 'Запит на поповнення схвалено',
  topup_request_rejected: 'Запит на поповнення відхилено',
  topup_creation_date: 'Дата створення',
  topup_updating_date: 'Дата оновлення',
  topup_list_tooltip: 'Використовуйте подвійне клацання миші для відкриття форми підтвердження',
  topup_otp_code_confirm: 'Підтвердження OTP коду',
  topup_secure_msg_status_1: 'Прийнятий для обробки',
  topup_secure_msg_status_2: 'Перевірка карти на 3DS',
  topup_secure_msg_status_3: 'Очікування подтвердження OTP',
  topup_secure_msg_status_4: 'Операція на черзі',
  topup_secure_msg_status_5: 'Операція в обробці',
  topup_secure_msg_status_6: 'Рахунок створено, очікує сплати',
  topup_secure_msg_status_7: 'По операції проведений розрахунок комісії',
  topup_secure_msg_status_10: 'Операція проведена',
  topup_secure_msg_status_20: 'Помилка верифікации 3DS',
  topup_secure_msg_status_21: 'Помилка проведения операції',
  // navbar
  nav_search: 'Знайти проєкт...',
  nav_not_verifying_user_msg: 'Функціонал вашого акаунту обмежений',
  nav_go_through_verification: 'пройдіть верифікацію',
  // dividends
  divid_fund_name: 'Назва проєкту',
  divid_tokens_issued: 'Кількість випущених активів',
  divid_total_investments: 'Загальна сума інвестицій',
  divid_total_payments: 'Загальна сума виплат по дивідендам',
  divid_payments_description: 'Введіть суму виплат дивідендів, яка буде розподілена між інвесторами',
  divid_investors_list: 'Список інвесторів',
  divid_to_pay: 'Дивіденди до виплати',
  divid_footer_description: 'Термін вашого проєкту закінчується через 15 днів — після цього ви будете зобов\'язані виплатити всі дивіденди інвесторам',
  divid_total_pay: 'Загальна сума виплат дивідендів',
  divid_your_balance: 'Ваш баланс',
  divid_pay_btn: 'Виплатити дивіденди інвесторам',
  divid_accept_pay: 'Ви підтверджуєте виплату дивідендів інвесторам?',
  divid_will_debited: 'Ми спишемо з вашого рахунку <span style="color: #FF873E">%{amount} %{currency}</span> і виконаємо масовий переказ інвесторам',
  divid_can_search: 'Ви зможете відстежити платіж кожному інвестору пізніше в розділі «Історія транзакцій»',
  divid_success_title: 'Чудово! Інвестори отримали свої дивіденди',
  divid_success_sub_title: 'Вітаємо вас із успішним завершенням проєкту. Ми раді, що CryptoPort допоміг вашій справі — для нас це теж перемога.',
  divid_success_text: 'Перевірити перекази інвесторам ви зможете в розділі «Історія транзакції»',
  divid_term_month: 'міс.',
  divid_tab_finish_title: 'Проєкт завершено — завантажте фінансовий звіт і виплатіть дивіденди інвесторам',
  divid_tab_finish_text: ', для того, чтоб завантажити фінансовий звіт',
  divid_ready_to_pay: 'Готові виплатити дивіденди інвесторам?',
  divid_ready_to_pay_text: 'Термін вашого проєкту закінчується через 15 днів — після цього ви будете зобов\'язані виплатити всі дивіденди інвесторам. Або можете зробити це раніше, наприклад, зараз.',
  divid_save_report: 'Завантажте сюди фінансовий звіт, щоб додати його до проєкту',
  divid_pay_error: 'Не вдалось виплатити дивіденди. Перевірте внесені дані або спробуйте пізніше',
  divid_pay_subject: 'Дивіденди з проєкту %{name}',
  // new
  swap_exchange: 'Swap обмін',
  operation_type: 'Тип операції',
  verification_needed_msg: 'Пройдіть верифікацію, щоб користуватися гаманцем та іншими функціями.',
  amount_step_title: 'Введіть суму',
  wallet_step_title: 'Адреса гаманця',
  crypto_chart_title: 'Криптовалюти'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/ua/ua_all.js